import { ErrorHandler, inject, Injectable } from '@angular/core';
import { UpdateService } from 'app/shared/services/update.service';

@Injectable()
export class LazyChunkErrorHandler implements ErrorHandler {
    private readonly _updateService = inject(UpdateService);

    handleError(error: unknown): void {
        if (this._updateService.applyStaleLazyChunkReload(error)) {
            return;
        }
        console.error(error);
    }
}
